import { Col, Container, Row } from 'react-bootstrap';
import { LogoutSuccessSVG } from '../../img/GlobalSVG';
import './ProviderRegistration.scss';

const ProviderRegistrationSuccess = () => {
  return (
    <Container className="mtop30 logout mx-0 px-0 m-auto">
      <div className="roller"></div>

      <Row className="h-100">
        <Col className="my-auto">
          <div id="tick-img">
            <LogoutSuccessSVG.LogoutSuccessSVG />
          </div>

          <Row className="w-50 mx-auto main-content ">
            <Col>
              <h1 className="self-reg-content">
                Your registration request has been submitted successfully!
              </h1>
            </Col>
          </Row>

          <Row className="reg-content">
            <Col>
              <p className="reg-info">
                {' '}
                We are reviewing your registration request. You will receive an
                email in your registered email address after the request has
                been approved.
              </p>

              <p className="reg-info">
                The email will contain a secure link to set up your Provider
                account. You will be able to log in to your account after you
                have completed your account setup.
              </p>

              <p className="reg-info">
                If you have any questions, get in touch with your Administrator.
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default ProviderRegistrationSuccess;
